import React from 'react';

import { useLocation, useParams } from 'react-router-dom';

import AppointmentDetail from './components/AppointmentDetail';
import ClassDetail from './components/ClassDetail';

const EventDetail = (): JSX.Element => {
  const { pathname } = useLocation();
  const { eventId } = useParams<{ eventId: string }>();

  const isClass = pathname.includes('classes');
  const isAppointment = pathname.includes('appointments');

  if (!eventId) {
    return <div>Event not found</div>;
  }

  return (
    <>
      {isClass ? <ClassDetail eventId={eventId} /> : null}
      {isAppointment ? <AppointmentDetail eventId={eventId} /> : null}
    </>
  );
};

export default EventDetail;
